<template>
    <div class="chooseStem_r">
        <mavon-editor v-if="show_mode == 2" class="md"  :value="value" :subfield="false" defaultOpen='preview' placeholder="" :editable="false" :toolbarsFlag="false" :ishljs="true"  :previewBackground="previewStyle" :codeStyle="mavonCodestyle"></mavon-editor>
        <span  v-else class="commonStem" v-html="value"></span>
    </div>
</template>
<script>
import {mavonEditor} from 'mavon-editor';
import 'mavon-editor/dist/css/index.css'
import 'highlight.js/styles/atelier-lakeside-dark.css';
import 'highlight.js/styles/github.css';
import Prism from "prismjs";
import $ from 'jquery';
export default{
    props:{
        value:{},
        show_mode:{
            default:2
        }
    },
    data(){
        return{
            previewStyle : this.themeVal == 'black' ? 'transparent' : 'transparent',//'#f8f8f8',
            mavonCodestyle : this.themeVal == 'black' ? 'atelier-lakeside-dark' :  'github',//'default',
        }
    },
    created(){
        this.$nextTick(()=>{
            this.initCodeStyle();
        })
    },
    
    components:{mavonEditor},
    methods:{
        initCodeStyle(){
            if(this.show_mode == 2)return;
            setTimeout(() => {
                $('.commonStem pre').removeClass().each(function () {
                    var languageType =  $(this).attr("type");
                    if (languageType) {
                    $(this).addClass("line-numbers language-"+languageType);
                    }else{
                    $(this).addClass("line-numbers language-jsp");
                    }
                });
                Prism.highlightAll();//这里加定时器让它后执行，不然没效果
            }, 0);
        }
    },
    watch:{
        value(){
            this.$nextTick(()=>{
                this.initCodeStyle();
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/common/questionStem.scss';
</style>

<style lang="scss">
    body{
        .chooseStem_r{
            .markdown-body .highlight pre, .markdown-body pre{
                font-size: 100% !important;
            }
            .markdown-body code{
                font-size: 100% !important;
            }
            .markdown-body blockquote, .markdown-body dl, .markdown-body ol, .markdown-body p, .markdown-body pre, .markdown-body table, .markdown-body ul{
                margin-bottom: 6px;
            }
        }
        

    }
    html[data-theme="black"]{
        .chooseStem_r{
            .markdown-body .highlight pre, .markdown-body pre{
                background-color: transparent !important;
            }
           
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/markdown/questionStem.vue